import {CookiePolicy} from "./cookie-policy";
import {expireAll} from "../../umbrella-common/common-functions";
import {environment} from "../../../environments/environment";


export class GoogleCookiesPolicy implements CookiePolicy {

	handle(cookiesNames: string[], isAccepted: boolean): void {
		if (isAccepted) {
			this.acceptGoogleAnalyticsCookies();
		} else {
			expireAll(cookiesNames, environment.cookiesDomain);
			this.enableGtag();
		}
	}

	private acceptGoogleAnalyticsCookies() {
		(function(w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({
				'gtm.start': new Date().getTime(), event: 'gtm.js'
			});
			var f = d.getElementsByTagName(s)[0];
			var j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
			// @ts-ignore
			j.async = true;
			j.setAttribute('nonce', 'bm9uY2U=');
			j.setAttribute('id', 'gtmScript');
			// @ts-ignore
			j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
			var n=d.querySelector('[nonce]');
			// @ts-ignore
			n&&j.setAttribute('nonce',n.nonce||n.getAttribute('nonce'));
			f.parentNode.insertBefore(j, f);
		})(window, document, 'script', 'dataLayer', this.getTagManagerId());
	}

	private getTagManagerId() {
		return environment.tagManagerId;
	}

	private enableGtag() {

		window.dataLayer = window.dataLayer || [];

		// Define gtag function
		window.gtag = function () {
			window.dataLayer.push(arguments);
		};

		// Dynamically load gtag.js
		const script = document.createElement('script');
		script.async = true;
		script.setAttribute('id', 'gtagScript');
		script.src = `https://www.googletagmanager.com/gtag/js?id=${this.getTagManagerId()}`;

		// Copy nonce if present (same as your GTM method)
		const nonceNode = document.querySelector('[nonce]');
		if (nonceNode) {
			const nonceValue = nonceNode.getAttribute('nonce') || (nonceNode as any).nonce;
			if (nonceValue) {
				script.setAttribute('nonce', nonceValue);
			}
		}

		document.head.appendChild(script);

		// Set default consent
		window.gtag('consent', 'default', {
			analytics_storage: 'denied',
			ad_storage: 'denied',
			wait_for_update: 500
		});

		// Initialize GA
		window.gtag('js', new Date());

		// Configure GA
		window.gtag('config', this.getTagManagerId());
	}

}

declare global {
	interface Window {
		dataLayer: any[];
		gtag: (...args: any[]) => void;
	}
}
